import { CatalogPayload } from "contexts/AnalyticsContext/AnalyticsEvents";
import { SearchQuery } from "hooks/search/types";
import { getActiveCanonicalFilterNames } from "./canonicalNames";

const DEFAULT_PAGE = 1;

export const buildCatalogPayload = (query: SearchQuery): CatalogPayload => {
  const activeNames = getActiveCanonicalFilterNames(query.filters);

  return {
    search_type: query.type,
    query: query.query,
    has_query: query.query.length > 0,
    active_filters: activeNames.join(","),
    active_filters_count: activeNames.length,
    has_filters: activeNames.length > 0,
    page: query.page ?? DEFAULT_PAGE,
  };
};
